// app/javascript/controllers/dae20/run_task_now_controller.js
import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus Controller для компонента run_task_now (Планировщик).
 *
 * POST /dae20/scheduler_tasks/:component_id/run_now — постановка задачи
 * в очередь solid_queue с trigger_source='manual'. Реальный запуск
 * асинхронный — результат появится в task.runs через несколько секунд.
 */
export default class extends Controller {
  static targets = ["runBtn", "result"]
  static values  = { componentId: String, taskId: String }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }

  async run(event) {
    event.preventDefault()

    if (!this.taskIdValue) {
      this.showResult("error", "Не определён task_id — откройте карточку задачи")
      return
    }

    if (this.hasRunBtnTarget) {
      this.runBtnTarget.disabled = true
      this.runBtnTarget.textContent = "Постановка в очередь…"
    }
    this.showResult("info", "Ставим задачу в очередь…")

    try {
      const url = `/dae20/scheduler_tasks/${this.componentIdValue}/run_now`
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        credentials: "same-origin",
        body: JSON.stringify({ task_id: this.taskIdValue })
      })

      const data = await response.json()

      if (data.ok) {
        this.showResult("success",
          `Задача «${data.task_code}» в очереди (job: ${data.job_id || "—"}).<br>`
          + `Обновите список запусков через ~5 сек.`)
        // Попробуем перезагрузить соседнюю таблицу запусков
        this.reloadRunsTable()
      } else {
        const errors = (data.errors || []).join(", ")
        this.showResult("error", `Ошибка: ${errors}`)
      }
    } catch (error) {
      this.showResult("error", `Сетевая ошибка: ${error.message}`)
    } finally {
      if (this.hasRunBtnTarget) {
        this.runBtnTarget.disabled = false
        this.runBtnTarget.textContent = "Запустить сейчас"
      }
    }
  }

  showResult(type, message) {
    if (!this.hasResultTarget) return
    const colors = {
      success: "text-green-700 bg-green-50 border-green-200",
      error:   "text-red-700 bg-red-50 border-red-200",
      info:    "text-blue-700 bg-blue-50 border-blue-200"
    }
    const colorClass = colors[type] || colors.info
    this.resultTarget.innerHTML =
      `<div class="px-3 py-2 rounded-lg border text-xs ${colorClass}">${message}</div>`
  }

  reloadRunsTable() {
    const tables = document.querySelectorAll('[data-component-type="table"]')
    tables.forEach(table => {
      const frame = table.closest('turbo-frame')
      if (frame && frame.src) frame.reload()
    })
  }
}
